'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tiered = require('datastore-core/tiered');
var get = require('dlv');
var pubsubDatastore = require('./pubsub-datastore.js');
var offlineDatastore = require('./offline-datastore.js');
var dhtDatastore = require('./dht-datastore.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

function createRouting({libp2p, repo, peerId, options}) {
  const ipnsStores = [];
  let pubsubDs;
  if (get__default["default"](options, 'EXPERIMENTAL.ipnsPubsub', false)) {
    const pubsub = libp2p.pubsub;
    const localDatastore = repo.datastore;
    pubsubDs = new pubsubDatastore.IpnsPubsubDatastore(pubsub, localDatastore, peerId);
    ipnsStores.push(pubsubDs);
  }
  if (get__default["default"](options, 'offline') || get__default["default"](options, 'config.Routing.Type', 'none') === 'none') {
    const offlineDatastore$1 = new offlineDatastore.OfflineDatastore(repo);
    ipnsStores.push(offlineDatastore$1);
  } else {
    ipnsStores.push(new dhtDatastore.DHTDatastore(libp2p._dht));
  }
  return new tiered.TieredDatastore(ipnsStores);
}

exports.createRouting = createRouting;
